import _ from "lodash";
import { tripServicesListSelector } from "./selector";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { currencies } from "../umbilical_tools";

export const PkgPriceInfoDataHydrator = (WrappedComponent) => {
  const Comp = (props) => {
    return <WrappedComponent {...props} />;
  };
  Comp.propTypes = { services: PropTypes.array.isRequired };
  const mapStateToProps = (state) => {
    const services = tripServicesListSelector(state);

    return { services };
  };

  return connect(mapStateToProps, null)(Comp);
};

export const PriceHoc = (WrappedComponent) => {
  const Comp = (props) => {
    const currencySymbol = _.get(currencies, _.get(props, "currency"), "");

    return <WrappedComponent {...props} currencySymbol={currencySymbol} />;
  };
  return Comp;
};
